import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "annex-alarm-sidebar"
}
const _hoisted_2 = { class: "annex-alarm-sidebar__overview" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "camera-title" }
const _hoisted_5 = {
  key: 1,
  class: "camera-title"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1)
const _hoisted_7 = { class: "date" }
const _hoisted_8 = { class: "annex-alarm-sidebar__thumbnails" }
const _hoisted_9 = { class: "annex-alarm-sidebar__confidence" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultisidebarHeader = _resolveComponent("MultisidebarHeader")!
  const _component_NTabs = _resolveComponent("NTabs")!
  const _component_SimpleOverlay = _resolveComponent("SimpleOverlay")!
  const _component_NIcon = _resolveComponent("NIcon")!
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_Confidence = _resolveComponent("Confidence")!
  const _component_CardItemRow = _resolveComponent("CardItemRow")!
  const _component_SidebarSection = _resolveComponent("SidebarSection")!
  const _component_AnnexAlarmFeatures = _resolveComponent("AnnexAlarmFeatures")!
  const _component_AnnexAlarmAcknowledgeInfo = _resolveComponent("AnnexAlarmAcknowledgeInfo")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_MultisidebarActions = _resolveComponent("MultisidebarActions")!

  return (_ctx.adaptedItem)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MultisidebarHeader, {
          class: _normalizeClass(_ctx.headerClasses),
          label: _ctx.item.title,
          tag: _ctx.$t('annex_alarms.statuses_one.' + _ctx.adaptedItem.status, 'f'),
          onAction: _ctx.handleAction
        }, {
          beforeActions: _withCtx(() => []),
          _: 1
        }, 8, ["class", "label", "tag", "onAction"]),
        _createVNode(_component_NTabs, {
          items: _ctx.tabItems,
          modelValue: _ctx.sidebarSharedState.activeTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sidebarSharedState.activeTab) = $event)),
          class: "multisidebar-content__tabs control-m"
        }, null, 8, ["items", "modelValue"]),
        (_ctx.sidebarSharedState.activeTab === 'info')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_SimpleOverlay, {
                class: "annex-alarm-sidebar__overlay",
                imageUrl: _ctx.adaptedItem.fullframe,
                bboxes: _ctx.adaptedItem.bboxes,
                line: _ctx.item?.extra?.line?.points,
                track: _ctx.adaptedItem.track,
                onClick: _cache[1] || (_cache[1] = () => _ctx.actionHandler('show-full-screen'))
              }, null, 8, ["imageUrl", "bboxes", "line", "track"]),
              _createElementVNode("div", _hoisted_2, [
                (_ctx.adaptedItem.camera?.name)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "camera-link",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.actionHandler('show-player'))),
                      title: `${_ctx.adaptedItem.cameraGroup?.name} / ${_ctx.adaptedItem.camera?.name}`
                    }, [
                      _createVNode(_component_NIcon, { name: "play" }),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.adaptedItem.cameraGroup?.name) + " / " + _toDisplayString(_ctx.adaptedItem.camera?.name), 1)
                    ], 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.item.stream), 1)),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formattedDate), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_NThumbnail, {
                  class: "annex-alarm-sidebar__thumbnail",
                  size: "large",
                  actions: _ctx.thumbnailActions,
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                  "model-value": _ctx.adaptedItem.thumbnail,
                  "not-found-image-label": _ctx.$t('annex_alarms.not_found'),
                  onAction: _cache[4] || (_cache[4] = () => _ctx.actionHandler('show-full-screen'))
                }, null, 8, ["actions", "model-value", "not-found-image-label"]),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.matchedCardHelper.card)
                    ? (_openBlock(), _createBlock(_component_Confidence, {
                        key: 0,
                        value: _ctx.confidence,
                        direction: "vertical"
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "annex-alarm-sidebar__card",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.matchedCardHelper.showCard()), ["stop"]))
                }, [
                  (_ctx.matchedCardHelper.card)
                    ? (_openBlock(), _createBlock(_component_CardItemRow, {
                        key: 0,
                        type: _ctx.matchedCardHelper.isTypeCars ? 'cars' : 'humans',
                        item: _ctx.matchedCardHelper.card,
                        selected: _ctx.matchedCardHelper.isSelected,
                        opened: _ctx.matchedCardHelper.isOpened,
                        showDate: false,
                        closeable: false,
                        thumbnailSize: "large"
                      }, null, 8, ["type", "item", "selected", "opened"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_SidebarSection, {
                title: _ctx.$t('annex_alarms.tags')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.item.tag), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(_component_SidebarSection, {
                title: _ctx.$t('annex_alarms.alarm_info'),
                date: _ctx.item.ack_at
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AnnexAlarmFeatures, {
                    features: _ctx.adaptedItem.features
                  }, null, 8, ["features"]),
                  _createVNode(_component_AnnexAlarmAcknowledgeInfo, {
                    item: _ctx.item,
                    "adapted-item": _ctx.adaptedItem
                  }, null, 8, ["item", "adapted-item"])
                ]),
                _: 1
              }, 8, ["title", "date"]),
              (_ctx.item.comment)
                ? (_openBlock(), _createBlock(_component_SidebarSection, {
                    key: 0,
                    title: _ctx.$t('annex_alarms.complete_with_comment'),
                    date: _ctx.item.updated_at
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.item.comment), 1)
                    ]),
                    _: 1
                  }, 8, ["title", "date"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.sidebarSharedState.activeTab === 'history')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_SidebarSection, {
                title: _ctx.$t('annex_alarms.new_alarm'),
                date: _ctx.item.declared_at
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.item.title), 1)
                ]),
                _: 1
              }, 8, ["title", "date"]),
              (_ctx.item.ack_value === 0)
                ? (_openBlock(), _createBlock(_component_SidebarSection, {
                    key: 0,
                    title: _ctx.$t('annex_alarms.rejected'),
                    date: _ctx.item.ack_at
                  }, {
                    default: _withCtx(() => [
                      (_ctx.history.acknowledge)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.history.acknowledge), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.ack_status.in_work')) + " " + _toDisplayString(_ctx.item.ack_author), 1)
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["title", "date"]))
                : _createCommentVNode("", true),
              (_ctx.item.ack_value === 1)
                ? (_openBlock(), _createBlock(_component_SidebarSection, {
                    key: 1,
                    title: _ctx.$t('annex_alarms.acknowledged'),
                    date: _ctx.item.ack_at
                  }, {
                    default: _withCtx(() => [
                      (_ctx.history.acknowledge)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.history.acknowledge), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_component_AnnexAlarmAcknowledgeInfo, {
                            key: 1,
                            item: _ctx.item
                          }, null, 8, ["item"]))
                    ]),
                    _: 1
                  }, 8, ["title", "date"]))
                : _createCommentVNode("", true),
              (_ctx.history.complete)
                ? (_openBlock(), _createBlock(_component_SidebarSection, {
                    key: 2,
                    title: _ctx.$t('annex_alarms.complete_with_comment'),
                    date: _ctx.item.updated_at
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.history.complete), 1)
                    ]),
                    _: 1
                  }, 8, ["title", "date"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.adaptedItem.acknowledge === 'none')
          ? (_openBlock(), _createBlock(_component_MultisidebarActions, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_NButton, {
                  size: "big",
                  type: "primary",
                  icon: "annex_success",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.actionHandler('ack_success')), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.acknowledge')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_NButton, {
                  size: "big",
                  type: "secondary",
                  icon: "annex_failure",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.actionHandler('ack_failure')), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.reject')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.item.comment)
            ? (_openBlock(), _createBlock(_component_MultisidebarActions, { key: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_NButton, {
                    size: "big",
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.actionHandler('addCommentAndComplete')), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.add_comment_and_complete')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}